import { PropsWithChildren } from 'react';
import { CartContext } from '.';
import { useGetCartItems } from '../../services/cart-item/cart-item.service';

export default function CartContextProvider({ children }: PropsWithChildren) {
  const _cartData = useGetCartItems();

  return <CartContext.Provider value={{ ..._cartData }}>{children}</CartContext.Provider>;
}
